import {observable, action, runInAction} from 'mobx'
import {StoreExt} from '@utils/reactExt'

class StoreFrontStore extends StoreExt {
    @observable layoutData: any[] = [];
    @action
    getStoreFrontLayout = async (page = '1') => {
        try {
            let arr = [];
            try {
                const res1 = await this.queryImageTextInfo(page);
                const res2 = await this.queryGoodsShelfInfo(page);
                const res3 = await this.queryShoppingGuildInfo(page);
                const res4 = await this.queryCustomInfo(page);
                const allEleData = [...res1, ...res2, ...res3, ...res4];
                const data = await this.api.queryLayout({page});
                data.forEach(item => {
                    const targetItem = allEleData.find(subItem => Number(subItem.elementIndex) === Number(item.elementIndex));
                    arr.push(targetItem || {})
                })
            } catch (e) {
                arr = []
            } finally {
                arr.splice(1, 0, {elementType: '-1'});
                runInAction(() => {
                    this.layoutData = arr
                })
            }
        } catch (e) {
        } finally {
        }
    };
    // 图文
    @action
    queryImageTextInfo = async (page) => {
        let data;
        try {
            data = await this.api.queryImageTextInfo({page});
        } catch (e) {
            data = []
        }
        return data
    };
    // 货架
    @action
    queryGoodsShelfInfo = async (page) => {
        let data;
        try {
            data = await this.api.queryGoodsShelfInfo({page});
        } catch (e) {
            data = []
        }
        return data
    };
    // 导购
    @action
    queryShoppingGuildInfo = async (page) => {
        let data;
        try {
            data = await this.api.queryShoppingGuildInfo({page});
        } catch (e) {
            data = []
        }
        return data
    };
    // 自定义
    @action
    queryCustomInfo = async (page) => {
        let data;
        try {
            data = await this.api.queryCustomInfo({page});
        } catch (e) {
            data = []
        }
        return data
    }
}

const storeFrontStore = new StoreFrontStore();
export {storeFrontStore, StoreFrontStore}
